export interface ChangelogEntry {
  version: string;
  date: string; // ISO format: YYYY-MM-DD
  changes: {
    type: "new" | "improved" | "fixed";
    description: string;
  }[];
}

export const CHANGELOG: ChangelogEntry[] = [
  {
    version: "1.29",
    date: "2026-09-04",
    changes: [
      {
        type: "new",
        description:
          "Profilvisning: organisasjons- og privatprofiler viser AML, MIFID og interne felter i faner basert pa profilskjemaenes XML-definisjoner",
      },
      {
        type: "improved",
        description:
          "Profilvisning: MIFID-kunnskap, erfaring, handelsfrekvens og periode presenteres samlet i en instrumentmatrise for bedre sammenligning",
      },
      {
        type: "improved",
        description:
          "Profilvisning: reelle rettighetshavere vises i en egen tabell, tomme standardrader filtreres bort, og organisasjonsfanene holder seg synlige ved scrolling",
      },
      {
        type: "fixed",
        description:
          "Profilvisning: privatpersoner bruker na riktige contact.cgProfiling-felter for arbeidssituasjon, midlenes opprinnelse, finansiell situasjon, risiko og ESG",
      },
      {
        type: "fixed",
        description:
          "DocProducer: Edit pa eksisterende ordre fyller na ut OrderFormNew med lagrede ordredata og oppdaterer samme dokument ved lagring",
      },
      {
        type: "fixed",
        description:
          "DocProducer: redigeringsstatus nullstilles ved lukking og ved opprettelse av ny ordre, slik at gamle ordreverdier ikke gjenbrukes",
      },
      {
        type: "fixed",
        description:
          "Kontaktoppdatering: prospects identifiseres med en runtime type guard i stedet for instanceof, siden GraphQL-data er plain objects",
      },
      {
        type: "improved",
        description:
          "AutoSuit: getTagNumber leser kommaseparerte tags som investmentHorizon-3 og returnerer korrekt numerisk suffiks",
      },
      {
        type: "improved",
        description:
          "Egnethetsvurdering: økonomioppsummeringen viser investering, kapitalbehov, likvid formue og netto formue som grunnlag for advarselen",
      },
      {
        type: "improved",
        description:
          "Egnethetsvurdering: advarselsteksten er oppdatert til Investering + Kapitalbehov overstiger Likvid formue",
      },
    ],
  },
  {
    version: "1.28",
    date: "2026-09-03",
    changes: [
      {
        type: "new",
        description:
          "Egnethetsvurdering: ny Suitability New-form med samlet vurdering av anbefalt aksjeandel, investeringshorisont, likviditet, tapstoleranse, investeringsmal og egnethetsstatus",
      },
      {
        type: "new",
        description:
          "Egnethetsvurdering: stotte for Scope A og Scope B, inkludert registrering av aksjer, renter, kontanter og andre investeringer utenfor Capguard",
      },
      {
        type: "improved",
        description:
          "Egnethetsvurdering: AutoSuit beregner na total aksjeandel for og etter ordre, anbefalt andel, finansielle intervaller, likviditetsbehov og sentrale felter til dokumentgenerering",
      },
      {
        type: "fixed",
        description:
          "Egnethetsvurdering: gyldige numeriske nullverdier beholdes i stedet for a bli konvertert til null ved serialisering av skjemaet",
      },
      {
        type: "improved",
        description:
          "Egnethetsvurdering: profilverdier kan na hentes fra bade korte profilnokler og fullstendige contact.cgProfiling-/contact.profiling-nokler, med fallback for organisasjons- og privatkundevarianter",
      },
      {
        type: "fixed",
        description:
          "Egnethetsvurdering: hasPerformanceFee sjekker na faktisk resultatbasert gebyr (actPerfFee) og ikke kontogebyr",
      },
      {
        type: "new",
        description:
          "Ordre: ny ordreform med forbedret registrering av modellordrer, instrumentordrer, kjop/salg-linjer og sikkerhetsdetaljer",
      },
      {
        type: "improved",
        description:
          "Ordre og egnethetsdokumenter: gebyrer, kickback, tegningskostnader, forvaltningskostnader og resultatbaserte gebyrer beregnes per ordre og aggregeres i dokumentdata",
      },
      {
        type: "new",
        description:
          "DocProducer: Suitability New-dokumenter kan na sendes til produksjon med strukturerte data, inkludert arrays og nestede objekter",
      },
      {
        type: "improved",
        description:
          "DocProducer: importProfile og updateMainContact fra signerte skjemaer flettes automatisk inn som profiloverstyringer, der updateMainContact har prioritet ved duplikate felt",
      },
      {
        type: "fixed",
        description:
          "DocProducer: forhåndsopprettede kundeprofil-dokumenter fjernes igjen dersom brukeren trykker Cancel uten a sende inn skjemaet",
      },
      {
        type: "new",
        description:
          "DocProducer: dokumenter som produseres fra kundeprofil, MIFID2 og KYC vises i dokumentlisten med egen dokumenttype og oppdatert forhåndsvisning",
      },
      {
        type: "improved",
        description:
          "DocProducer: produksjonslisten har bredere dokumentpanel, egen signatarvisning og krever eksplisitt valg av signatarer før signering",
      },
      {
        type: "improved",
        description:
          "Kundeprofil og KYC: skjemaene støtter dynamiske inpData-verdier, datofelt og forbedret forhåndsutfylling for privatpersoner og organisasjoner",
      },
      {
        type: "new",
        description:
          "Trader: ny porteføljevisning med samlet oversikt, dual-bar, eksponeringsdetaljer og forbedret navigering mellom porteføljer og beholdninger",
      },
      {
        type: "improved",
        description:
          "Kontooversikt: beholdninger og porteføljeytelse viser flere markeds- og enhetspriser, med forbedret lasting, responsiv layout og mer presise ytelsesdata",
      },
      {
        type: "improved",
        description:
          "Porteføljevisning: kontantbeholdning, aktive ordre og beholdningsdata hentes og presenteres mer presist pa kontoniva",
      },
      {
        type: "improved",
        description:
          "Kontakter: kontaktinformasjon, representanter, porteføljer og profilvisning er oppdatert med mer kompakt layout og bedre håndtering av manglende data",
      },
      {
        type: "improved",
        description:
          "E-post: søk, visning og lagring av e-poster er forbedret, inkludert mer robust dra-og-slipp mellom siste og lagrede e-poster",
      },
      {
        type: "new",
        description:
          "Prospekter: forbedret opprettelse og konvertering av prospekter til kontakter, inkludert bedre validering av kontaktinformasjon",
      },
      {
        type: "improved",
        description:
          "Skjemaer: Form.io-styling er modernisert med tydeligere felt, faner, radioknapper, validering, tooltip-visning og flytende detaljpaneler",
      },
      {
        type: "fixed",
        description:
          "Tilgjengelighet og stabilitet: flere MUI-advarsler rundt deaktiverte knapper, dialogbeskrivelser og kalender-/tooltip-lagdeling er fjernet",
      },
      {
        type: "improved",
        description:
          "Lasting: logoanimasjon og mer konsistente lastetilstander er tatt i bruk i skjemaer og sentrale visninger",
      },
    ],
  },
  {
    version: "1.27",
    date: "2026-08-10",
    changes: [
      {
        type: "improved",
        description:
          "Kontooversikt – aktivaallokering: donut-chart og legend viser nå et pulserende skjelett under lasting, slik at seksjonen holder plass og ikke spretter inn etter at data er lastet",
      },
      {
        type: "new",
        description:
          "Koblinger (Connections): listen viser nå maks 3 koblinger som standard; har kunden flere vises et '+N til'-valg som ekspanderer listen inline uten å åpne en ny dialog",
      },
      {
        type: "new",
        description:
          "Verdipapirytelse – sortering: kolonneoverskriftene er nå klikkbare og lar brukeren velge hvilken tidsperiode tabellen skal sorteres etter; aktiv kolonne markeres med fet tekst og retningsikon (opp/ned etter variant)",
      },
      {
        type: "improved",
        description:
          "Verdipapirytelse – layout: horisontal padding redusert fra px-3 til px-2 på alle celler, 'MONTH'-etiketten forkortet til '1M', og verdipapirnavn-kolonnen smalnet inn — eliminerer horisontal scroll på kortet",
      },
      {
        type: "fixed",
        description:
          "Møterom – tidsluke-tooltip: tooltip dukket opp i øverste venstre hjørne fordi span-wrapperen hadde display:contents som gir tom bounding box; fikset ved å gi span flex-1 h-12 slik at MUI kan beregne korrekt posisjon",
      },
      {
        type: "fixed",
        description:
          "Kurshistorikk-dialog: fjernet Radix UI-advarsel om manglende DialogDescription ved å sette aria-describedby={undefined} på DialogContent",
      },
    ],
  },
  {
    version: "1.26",
    date: "2026-08-07",
    changes: [
      {
        type: "new",
        description:
          "Kontooversikt – aktivaallokering: nytt donut-chart i venstrepanelet viser porteføljens fordeling per aktivaklasse og kontanter med prosent; oppdateres automatisk ved valg av enkeltportefølje",
      },
      {
        type: "improved",
        description:
          "Ny prospekt – validering: e-postfeltet oppdager nå om et telefonnummer er tastet inn og gir beskjed om riktig felt; telefonfeltet oppdager e-postadresse (inneholder @) og gir tilsvarende veiledning",
      },
      {
        type: "fixed",
        description:
          "E-post – dra og slipp: intern drag fra 'Siste e-poster' til 'Lagrede e-poster' ble ikke lagret fordi dataTransfer.items alltid inneholder text/html ved DOM-drag i Chromium; fikset ved å sjekke draggedEmail-tilstand først og bruke dataTransfer.files for Outlook-filopplasting",
      },
      {
        type: "improved",
        description:
          "ViewToggle: støtter nå varianten 'icon-text' som viser ikon og tekst side om side; tekst-varianten viser også ikon dersom det er oppgitt",
      },
      {
        type: "fixed",
        description:
          "Møterom – MUI-advarsler: Tooltip rundt deaktivert oppdater-knapp og fullvisning-knapp er nå pakket inn i <span> for å unngå MUI-advarsel om hendelseslytter på deaktivert element",
      },
      {
        type: "fixed",
        description:
          "Møterom – kalender: intern rullefelt i MUI StaticDatePicker er skjult ved å sette overflow: hidden på Paper og overflowY: hidden på MuiPickersSlideTransition-root",
      },
      {
        type: "fixed",
        description:
          "Møtebeskrivelse – Tiptap: fjernet eksplisitt Underline-utvidelse siden StarterKit v3 bundler Underline automatisk, noe som eliminerte 'duplicate extension' console-feilen",
      },
      {
        type: "improved",
        description:
          "Prisliste: Depot-raden viser nå en merknad '0,15 % for aksjesparekonto' som subtekst under tier-etiketten",
      },
    ],
  },
  {
    version: "1.25",
    date: "2026-06-23",
    changes: [
      {
        type: "fixed",
        description:
          "ECharts – StrictMode race condition: fixed 'Cannot read properties of undefined (reading disconnect)' errors in React StrictMode by delaying chart initialization with requestAnimationFrame",
      },
      {
        type: "new",
        description:
          "ECharts – SafeReactECharts wrapper: created unified wrapper component that safely mounts all echarts-for-react instances across the app, preventing double-mount cleanup race conditions",
      },
      {
        type: "improved",
        description:
          "Order data – Manual order rows: each row in manualOrderRows now includes an optional security object with full QuerySecurity details, automatically populated by matching instrumentCode and instrumentName",
      },
      {
        type: "new",
        description:
          "Pricelist component: new modern pricing table component with MUI Dialog, displaying management fees per portfolio model and capital interval; accessible via icon button",
      },
      {
        type: "improved",
        description:
          "TradingView widget: updated market overview symbols to show OBX, S&P500, Nasdaq, HangSeng, NIKKEI225, BRENT, GOLD, USDNOK, EURNOK, JPYNOK, DNB, SBNorge, and Entra",
      },
    ],
  },
  {
    version: "1.24",
    date: "2026-06-10",
    changes: [
      {
        type: "fixed",
        description:
          "App-oppdatering: 'New Version'-popup lukkes nå umiddelbart ved klikk på Update/Refresh, i stedet for å bli stående synlig til full side-reload er ferdig",
      },
      {
        type: "fixed",
        description:
          "DocProducer – Test-parametre: forhåndsutfylling i egnethetspanelet håndterer nå både contact.cgProfiling og contact.profiling, samt fallback mellom relevante org-/privatnøkler for investeringshorisont og investeringsmål",
      },
      {
        type: "improved",
        description:
          "DocProducer – Test-parametre: robust verdi-normalisering i nedtrekksfelter matcher nå også tekstvarianter (label-verdier, diakritiske tegn, skilletegn og formateringsvariasjoner), slik at eksisterende profilverdier vises korrekt",
      },
      {
        type: "improved",
        description:
          "Egnethetsdata: port_stock_pct og port_bond_pct lagres nå med fire desimaler for å gi presis prosentvisning med to desimaler i UI",
      },
      {
        type: "new",
        description:
          "Kontooversikt – beholdninger: verdipapirer med aktive ordre (stjerne) har nå tooltip ved hover med nåværende posisjon, +/- ordre i antall andeler, handelsbeløp og beregnet posisjon etter ordre",
      },
      {
        type: "fixed",
        description:
          "Kontooversikt – beholdnings-tooltip: ordreretning beregnes nå fra type.amountEffect (ikke fortegn på amount), slik at kjøp/salg aggregeres korrekt også når amount alltid er positiv",
      },
      {
        type: "fixed",
        description:
          "Kontooversikt – beholdnings-tooltip: tooltipen er nå riktig forankret til raden og breddebegrensning er fjernet, slik at bakgrunn og innhold holder samme bredde uten tekst som flyter utenfor",
      },
    ],
  },
  {
    version: "1.23",
    date: "2026-06-04",
    changes: [
      {
        type: "improved",
        description:
          "Kontooversikt: cash-rader aggregeres nå på kontonummer i kontaktvisning, slik at samme konto på tvers av porteføljer vises som én samlet rad",
      },
      {
        type: "fixed",
        description:
          "Kontooversikt: pending-badge, amber-markering og tooltip på cash-raden knyttes nå til faktisk konto via account-feltet på transaksjoner og handelsordre, slik at pending kun vises på riktig konto",
      },
      {
        type: "new",
        description:
          "Kontooversikt: verdipapirer med aktive handelsordre vises nå også i beholdningsoversikten selv uten eksisterende beholdning, med 0 i qty, kost, markedsverdi og andel",
      },
      {
        type: "new",
        description:
          "Faktaark: ny 'Holdings Comparison'-seksjon viser beholdning mellom to valgte datoer med fra/til-datovelgere, verdipapirnavn, antall andeler og andel av porteføljen",
      },
      {
        type: "fixed",
        description:
          "Faktaark: datovelger-popup i 'Holdings Comparison' vises nå foran dialogvinduet i stedet for bak, slik at kalenderen er fullt brukbar",
      },
      {
        type: "improved",
        description:
          "Kontooversikt: venstrepanelet er gjort bredere, og porteføljelisten viser nå porteføljenavn, shortName og modellportefølje over flere linjer for bedre lesbarhet",
      },
      {
        type: "fixed",
        description:
          "Faktaark: 'Holdings Comparison' henter nå fra- og til-data uten cache-kollisjon, slik at Share (from) ikke blir overskrevet når to-dato endres",
      },
      {
        type: "improved",
        description:
          "Faktaark: 'Holdings Comparison' har fått en ny 'Change'-kolonne med ikon, fargekodet endring og mini-indikator for rask visuell sammenligning av utvikling i andel",
      },
    ],
  },
  {
    version: "1.22",
    date: "2026-06-03",
    changes: [
      {
        type: "new",
        description:
          "Rapport: 7 rapporter er nå tilgjengelige — Kunderapport enkel, Kunderapport utvidet, Kunderapport v1.0, Transaksjonsliste (PDF), Transaksjonsliste (XLSX), Realisert og urealisert avkastning enkel og utvidet",
      },
      {
        type: "new",
        description:
          "Rapport – Transaksjonsliste (PDF): valg mellom 'Original purchase value' og 'Transaction purchase value' vises automatisk for rapporter som krever dette",
      },
      {
        type: "new",
        description:
          "Rapport: rapport-dialogen er nå bredere (MUI Dialog) med tokolonne-layout — rapportliste og datovelger til venstre, porteføljer til høyre — og støtter scroll ved mange valg",
      },
      {
        type: "improved",
        description:
          "Rapport: portefølje-oversikten er redesignet — kompakt listevisning med portefølje-ID (monospace), navn og modellportefølje på én rad",
      },
      {
        type: "improved",
        description:
          "Rapport: 'Velg alle / Fjern alle'-knapp erstatter gammel avmerkingsboks på kontaktnivå; teller viser antall valgte av totalt tilgjengelige porteføljer",
      },
      {
        type: "fixed",
        description:
          "Rapport: telleren kunne vise feil antall (f.eks. 8/7) fordi valgte porteføljer inkluderte inaktive porteføljer — kun aktive porteføljer (status A) telles nå",
      },
      {
        type: "fixed",
        description:
          "Rapport: lasteskjelett dukket opp over eksisterende porteføljer ved gjenåpning — vises nå kun ved første lasting uten cachet data",
      },
      {
        type: "fixed",
        description:
          "Rapport: nedtrekkslister og datovelgere ble skjult bak dialog-vinduet — z-indeks er nå korrekt slik at alle popovers vises foran dialogen",
      },
      {
        type: "new",
        description:
          "Transaksjoner: transaksjonstype-filteret støtter nå flervalg — velg én eller flere typer samtidig; resultater fra alle valgte typer hentes parallelt og slås sammen",
      },
      {
        type: "new",
        description:
          "Transaksjoner: avkryssingsbokser i tabellen gjør det mulig å velge enkelttransaksjoner og laste ned kontraktnoter (PDF) for de valgte radene",
      },
      {
        type: "new",
        description:
          "Transaksjoner: bunntekst-rad viser totalt antall transaksjoner, totale enheter og samlet handelsbeløp for gjeldende søkeresultat",
      },
      {
        type: "new",
        description:
          "Transaksjoner: advarselsbanner vises når søkefilteret er for bredt — tre nivåer (lav/medium/høy) avhengig av datospenn og manglende tilleggsfiltre",
      },
      {
        type: "improved",
        description:
          "Transaksjoner: nedtrekksliste for transaksjonstype tilpasser seg nå innholdets bredde automatisk uten at selve inputfeltet blir større",
      },
      {
        type: "improved",
        description:
          "Egnethetsvurdering: dokumentgenerering beregner nå alle sentrale felter — anbefalt aksjeandel (band og maks), equity-flagg (within/under/over), investeringshorisont, likviditetsbehov, tapstoleransee, investeringsmål og finansielle bandtekster",
      },
    ],
  },
  {
    version: "1.21",
    date: "2026-05-27",
    changes: [
      {
        type: "fixed",
        description:
          "Møtedetaljer: beskrivelse viste rå HTML-kode i stedet for lesbar tekst — konverteres nå korrekt til ren tekst",
      },
      {
        type: "fixed",
        description:
          "Rediger møte: beskrivelse viste rå HTML-kode ved åpning av eksisterende møte — vises nå som ren tekst med bevarte linjeskift",
      },
      {
        type: "fixed",
        description:
          "Rediger møte: linjeskift i beskrivelse sendes nå korrekt med i møteinnkallelsen",
      },
      {
        type: "fixed",
        description:
          "Møtedetaljer: krasj ved åpning av møter der deltakerstatus eller e-postadresse mangler fra Graph API",
      },
      {
        type: "fixed",
        description:
          "Møtedetaljer: krasj ved oppslag av tilknyttede kontakter når contactMap var tom/null",
      },
    ],
  },
  {
    version: "1.20",
    date: "2026-05-22",
    changes: [
      {
        type: "new",
        description:
          "Ytelse: ny periodesammendrag-seksjon i utvidet visning — viser startverdni, sluttverdni, netto inn/uttak, avkastning i NOK, maks drawdown og maks drawup som statistikkort",
      },
      {
        type: "new",
        description:
          "Ytelse: waterfall-diagram i utvidet visning illustrerer sammenhengen mellom startverdi, netto cashflow og avkastning frem til sluttverdi med animerte søyler",
      },
      {
        type: "new",
        description:
          "Ytelse: nedlastingsknapp i utvidet visning eksporterer hele diagramseksjonen som PNG",
      },
    ],
  },
  {
    version: "1.19",
    date: "2026-05-21",
    changes: [
      {
        type: "new",
        description:
          "Møterom – månedsvisning: '+'-knapp under datotallet i hver dag-boks lar deg opprette et møte direkte uten å åpne dagsvisningen",
      },
      {
        type: "improved",
        description:
          "Møterom – månedsvisning: grense for kompakt badge-layout hevet til 5+ hendelser per dag; 1–4 hendelser vises alltid som brede rader med starttidspunkt til høyre",
      },
      {
        type: "improved",
        description:
          "Møterom – månedsvisning: enkelthendelses-raden viser nå starttidspunkt og varighet (f.eks. '10:00 · 1t 30m') til høyre for tittelen",
      },
      {
        type: "fixed",
        description:
          "Møterom – ukesvisning: dra i topp-håndtaket for å flytte starttidspunkt fungerer nå korrekt; hendelsen forlenges ikke lenger nedover ved drag oppover",
      },
      {
        type: "fixed",
        description:
          "Møterom – ukesvisning: hendelseshøyder stemmer nå nøyaktig med sluttidspunkt; border-piksler per rad er medregnet i høydeberegningen",
      },
    ],
  },
  {
    version: "1.18",
    date: "2026-05-20",
    changes: [
      {
        type: "improved",
        description:
          "Kontooversikt: cash-raden viser nå en 'orders'-badge og amber-bakgrunn også når det finnes ueksekverterte handelsordre, ikke bare ved uoppgjorte transaksjoner",
      },
      {
        type: "new",
        description:
          "Kontooversikt: tooltip på cash-raden har fått en ny seksjon for ueksekverterte handelsordre — viser tilgjengelig kontantbeholdning, cashflow fra ordrer og estimert saldo etter eksekverting",
      },
      {
        type: "improved",
        description:
          "Kontooversikt: tooltip er forankret til pending-badge-en (ikke hele raden) slik at den plasseres til høyre der det er mer rom",
      },
      {
        type: "improved",
        description:
          "DocProducer – Quality-menyen: KYC Org og KYC Privat er fjernet fra nedtrekksmenyen",
      },
      {
        type: "improved",
        description:
          "DocProducer – Quality- og Kundeprofil-menyene: nedtrekkselementene viser nå ikon og kort beskrivelsestekst for enklere orientering",
      },
    ],
  },
  {
    version: "1.17",
    date: "2026-05-19",
    changes: [
      {
        type: "new",
        description:
          "CapguardPoll: internal voting widget added to the header bar — displays active polls as pill badges and opens a dialog for voting, changing or removing your vote",
      },
      {
        type: "new",
        description:
          "CapguardPoll: vote submission writes directly to the poll's keyFigures string; a pre-submit refetch ensures concurrent votes from different advisors are never overwritten",
      },
      {
        type: "new",
        description:
          "CapguardPoll: 'Fjern stemme' button lets an advisor retract their vote on any open poll",
      },
      {
        type: "new",
        description:
          "CapguardPoll: voter overview panel on the right side of the dialog — voters are grouped under the option they voted for, each group showing option name, colour indicator and vote count",
      },
      {
        type: "improved",
        description:
          "CapguardPoll: option buttons show vote count alongside percentage (e.g. '3 · 75%') and use a per-option colour palette that is consistent between the vote buttons and the voter list",
      },
      {
        type: "improved",
        description:
          "CapguardPoll: poll data is refetched automatically when the dialog opens so results are always up to date",
      },
      {
        type: "improved",
        description:
          "CapguardPoll: header badge shows a pulsing indigo dot when the user has not yet voted on an open poll, and a blue checkmark with the chosen option label after voting",
      },
    ],
  },
  {
    version: "1.15",
    date: "2026-05-18",
    changes: [
      {
        type: "improved",
        description:
          "Performance chart redesigned: market value removed from the inline chart for a cleaner single-series TWR view — full detail is available in the new expanded dialog",
      },
      {
        type: "new",
        description:
          "Performance card: Expand button added in the card header — opens a large dialog with a dual-axis chart (TWR % and market value), data zoom slider, legend toggle, min/max markers and a zero baseline",
      },
      {
        type: "improved",
        description:
          "Performance card: portfolio selector is now also rendered inside the expanded dialog so portfolios can be changed without closing the detail view — selection state is shared with the card header",
      },
      {
        type: "improved",
        description:
          "Performance card: expanded view now uses the MUI Dialog component for consistency with the rest of the application",
      },
      {
        type: "improved",
        description:
          "Portfolio dialog – Holdings: a Collapse all / Expand all toggle was added next to the Security column header — switches between chevron icons based on the current state of the asset class groups",
      },
      {
        type: "improved",
        description:
          "Meeting minutes form: Participants field modernised — replaced the free-text input with a chip list backed by an Autocomplete that pulls suggestions from advPortalContactsSimple, while still allowing manual entries",
      },
      {
        type: "fixed",
        description:
          "Profile card: the 'Below recommended' status badge no longer wraps onto two lines",
      },
      {
        type: "improved",
        description:
          "Profile card: equity share gauge pulled up slightly to tighten the spacing below the section title without affecting the title position",
      },
      {
        type: "new",
        description:
          "Performance chart: market value is now shown as a secondary area chart below the TWR line — uses a separate grid with indigo styling so the two series are visually distinct",
      },
      {
        type: "improved",
        description:
          "Performance chart: the two chart grids share a linked axis pointer — hovering anywhere on the chart highlights both the TWR and market value position simultaneously",
      },
      {
        type: "improved",
        description:
          "Performance chart tooltip: correctly resolves TWR percentage regardless of which chart area is hovered (fixed issue where market value numbers were displayed as %)",
      },
      {
        type: "new",
        description:
          "Portfolio dialog: draggable resize handle added between the holdings table and transaction list — drag up or down to adjust the split height",
      },
      {
        type: "new",
        description:
          "DocProducer: Kundeprofil dropdown added next to the Quality button — opens the capguard-kycVer2 form with three options: Kundeprofil (updateType 1), MIFID2-profil (updateType 2), AML-spørsmål (updateType 3)",
      },
      {
        type: "improved",
        description:
          "DocProducer: Kundeprofil form receives selContactId, selContactName, updateType and userProfile both as process values and as formDefinition.inpData so the form can pre-populate correctly",
      },
      {
        type: "improved",
        description:
          "Order document card in DocProducer redesigned with a horizontal fintech-style layout: icon badge, portfolio/model info, fee type pill, and an amounts grid with gap dividers",
      },
      {
        type: "new",
        description:
          "DocProducer – Quality dropdown: 'Open customer instruction' added — opens a form with Headline and Content fields and produces capOpenDoc.pdf (productionType / productionDokName: 'Åpen kundeinstruks')",
      },
      {
        type: "new",
        description:
          "DocProducer – Quality dropdown: 'Advisory against' added — opens a form with two reason checkboxes (rendered as 'X' in the PDF) and a free-text details field, producing docReject.pdf (productionType: 'Frarådning')",
      },
      {
        type: "improved",
        description:
          "DocProducer dialog: minimize and restore animations are now smooth — position is interpolated via calc()-based left/top instead of flipping between left/top and right/bottom, so the window glides between docked and floating states without snapping",
      },
      {
        type: "improved",
        description:
          "DocProducer dialog: the floating window can now be dragged past the left edge of the viewport, which makes the title-bar buttons reachable when the screen is narrow (a ~100 px safety margin is kept on the right and bottom so the dialog can always be grabbed back)",
      },
    ],
  },
  {
    version: "1.14",
    date: "2026-05-13",
    changes: [
      {
        type: "new",
        description:
          "Portfolio dialog – Holdings: securities are now grouped by asset class (classType1) with collapsible group headers showing aggregated cost, market value, P&L and share",
      },
      {
        type: "new",
        description:
          "Portfolio dialog – Holdings: expand/collapse per group — clicking a group header folds or unfolds its rows; a chevron icon rotates to indicate state",
      },
      {
        type: "new",
        description:
          "Portfolio dialog – Holdings: PP/unit column added (purchase price per unit)",
      },
      {
        type: "new",
        description:
          "Portfolio dialog – Holdings: Share% column replaces P&L% — shows each security's share of total portfolio value",
      },
      {
        type: "new",
        description:
          "Portfolio dialog – Holdings: a hollow circle indicator (○) is shown next to a security name when there is a booked transaction (TD ≤ today) whose settlement date is still in the future",
      },
      {
        type: "new",
        description:
          "Portfolio dialog – Cash: hovering a cash row now shows a cashflow tooltip with unsettled transactions and running balance per settlement date",
      },
      {
        type: "improved",
        description:
          "Portfolio dialog – Cash tooltip: cashflow per date is calculated using the transaction type's cashFlowEffect so that buys, sells, deposits and withdrawals each contribute the correct sign to the cash balance",
      },
      {
        type: "improved",
        description:
          "Portfolio dialog – Cash tooltip: open/executable orders (orderStatus 1 and 4) are included in the settlement schedule with SD ≥ today; only regular transactions (status OK) adjust the Current balance",
      },
      {
        type: "improved",
        description:
          "Portfolio dialog: default end-date for the transaction date range is now today + 1 month",
      },
      {
        type: "improved",
        description:
          "Portfolio dialog – Transactions: settlement date column added to the transaction list",
      },
      {
        type: "improved",
        description:
          "Portfolio dialog – Holdings: switching portfolio (or back to «All») now resets the selected security so the transaction list is cleared",
      },
    ],
  },
  {
    version: "1.13",
    date: "2026-05-12",
    changes: [
      {
        type: "new",
        description:
          "New Meeting: prospects (with or without email) can now be added as participants — those without an email are linked to the task but do not receive a calendar invitation",
      },
      {
        type: "new",
        description:
          "New Meeting: contacts with representatives (F-prefixed IDs) now show a «Reps» button in the participants list — clicking it opens a popover to quickly add or remove the contact's representatives",
      },
      {
        type: "improved",
        description:
          "Contact autocomplete: Contact/Prospect badge is now aligned to the right, next to the favourites star, for a cleaner layout",
      },
      {
        type: "fixed",
        description:
          "Contact autocomplete: prospects were never shown in the dropdown because the query skip-flag was inverted — prospects (with and without email) are now returned correctly when includeProspects is enabled",
      },
      {
        type: "fixed",
        description:
          "New Meeting / Prospect page: opening «New Event» from a prospect page now pre-fills the prospect in the participants list even when the prospect has no email address",
      },
      {
        type: "fixed",
        description:
          "New Meeting: a contact sharing the same email as the organizer could not be added to the participants list — deduplication now only checks against other Contact entries, not the Organizer or Advisor rows",
      },
      {
        type: "improved",
        description:
          "New Meeting: representatives the user has no access to are now shown as locked, greyed-out entries in the Reps popover instead of being silently hidden",
      },
      {
        type: "improved",
        description:
          "Contact info: connections the user has no access to are now shown as greyed-out, non-clickable rows with a lock icon instead of being fully interactive",
      },
    ],
  },
  {
    version: "1.12",
    date: "2026-05-07",
    changes: [
      {
        type: "new",
        description:
          "Portfolios: completely redesigned portfolio overview with a tabbed layout — Holdings, Transactions, and Contact details in one place",
      },
      {
        type: "improved",
        description:
          "Portfolios: holdings table now shows P&L and P&L % per row, cash accounts are grouped in a dedicated section",
      },
      {
        type: "improved",
        description:
          "Portfolios: portfolio selector sidebar shows securities value, cash, and cost at a glance alongside the portfolio list",
      },
      {
        type: "fixed",
        description:
          "Meeting minutes: form fields (place, date, participants, minutes) are now correctly passed to the PDF document",
      },
      {
        type: "fixed",
        description:
          "User menu: Microsoft login button was missing when the user was not connected but MSAL was not explicitly disabled — a «Connect Microsoft Account» button is now shown in that case",
      },
      {
        type: "fixed",
        description:
          "Update Contact Details: Update-button was never enabled for prospects because the address ID was missing from the GraphQL query",
      },
      {
        type: "improved",
        description:
          "Contact overview dialog: Market value in header now reflects the selected portfolio, P&L shows percentage in addition to absolute amount",
      },
      {
        type: "new",
        description:
          "Convert Prospect dialog: «Fetch from Brreg» button auto-fills company name and address from Brønnøysund Register when type is Company",
      },
      {
        type: "improved",
        description:
          "Prospects list: search term and results are now persisted in session storage so the list is restored after navigating back from a prospect",
      },
      {
        type: "fixed",
        description:
          "Meeting Rooms: calendar data was being polled every 20 seconds even when the dialog was closed — polling now only runs while the dialog is open",
      },
      {
        type: "fixed",
        description:
          "Meeting Rooms: rooms the user has no access to were shown as fully available (green) if another user had previously loaded the data within the cache window — stale cache entries are now cleared on authorization errors",
      },
      {
        type: "fixed",
        description:
          "Absence Calendar: backoffice users could see the «Employee Overview» button but clicking it had no effect — the dialog is now correctly rendered for backoffice users as well as admins",
      },
    ],
  },
  {
    version: "1.11",
    date: "2026-05-05",
    changes: [
      {
        type: "improved",
        description:
          "DocProducer: signing flow now picks the most recent task created within the last 2 minutes for improved reliability",
      },
      {
        type: "new",
        description:
          "DocProducer: signing links shown per signatory in the document sidebar with copy-to-clipboard",
      },
      {
        type: "improved",
        description:
          "DocProducer: Order, Quality and Upload buttons are disabled while a production or signing flow is active",
      },
      {
        type: "fixed",
        description:
          "DocProducer: nested button HTML error in the attachment list resolved",
      },
      {
        type: "improved",
        description:
          "Email task details dialog: sticky header, metadata and body in separate cards, coloured icon badges per field",
      },
      {
        type: "improved",
        description:
          "Email: HTML body is converted to plain text when saving an email task to Flowable",
      },
      {
        type: "improved",
        description:
          "Order form: bank account is now required — must select an existing account or enter a new one",
      },
    ],
  },
  {
    version: "1.10",
    date: "2026-04-30",
    changes: [
      {
        type: "new",
        description:
          "Update Details button on prospect page — edit address, email and phone",
      },
      {
        type: "improved",
        description:
          "Update Contact Details dialog now supports both contacts and prospects",
      },
      {
        type: "new",
        description: "Prospect detail page with notes, activities and notepad",
      },
      { type: "new", description: "New Event button on prospect page" },
      {
        type: "new",
        description:
          "Prospects shown in meeting participant search with badge (Prospect / Contact)",
      },
      {
        type: "new",
        description: "Version badge in logo — click to view changelog",
      },
      {
        type: "improved",
        description:
          "Duplicate check when adding prospect: validates name, email and phone against both prospects and contacts",
      },
      {
        type: "improved",
        description:
          "Phone duplicate detection is country-code aware (+47 / 0047)",
      },
      {
        type: "fixed",
        description: "Redirect to prospect list if prospect is not found",
      },
    ],
  },
  {
    version: "1.9",
    date: "2026-03-15",
    changes: [
      {
        type: "new",
        description:
          "Norwegian public holidays highlighted in holiday calendar",
      },
      {
        type: "improved",
        description: "Holiday names shown inline in calendar cells",
      },
    ],
  },
];
